export const  GET_MESSAGES = "GET_MESSAGES"
export const SIGNUP = 'SIGNUP'
export const SET_DISPLAY_MESSAGE = "SET_DISPLAY_MESSAGE"
export const LOGOUT = "LOGOUT"
export const LOGIN = "LOGIN"
export const UPDATE_SOCKET_ID = "UPDATE_SOCKET_ID "
export const GET_SOCKET_FROM_NAME = "GET_SOCKET_FROM_NAME"
export const SET_SOCKET = "SET_SOCKET"
export const SEND_FRIEND_REQUEST = "SEND_FRIEND_REQUEST"
export const GET_USER_DETAILS = "GET_USER_DETAILS"
export const FRIEND_REQUEST_RESPONSE = "FRIEND_REQUEST_RESPONSE"
export const NEW_MESSAGE = "NEW_MESSAGE"
export const SET_TYPING = "SET_TYPING"
export const OPEN_CHAT = "OPEN_CHAT"
export const SEND_MESSAGE = "SEND_MESSAGE"
export const CLOSE_CHAT = "CLOSE_CHAT"
export const SET_RECENT_MESSAGES_ARRAY = "SET_RECENT_MESSAGES_ARRAY"